/**
 * Configurações específicas para o cliente "Seu Crédito"
 */

const settings: ClientSettings = {
  name: "Seu Crédito",
  in100authority: "Seu Crédito",
  downloadTermText: "Seu Crédito",
  theme: {
    token: {
      colorPrimary: "#042940",
    },
  },
  assets: {
    logo: "/logo-seucredito.png",
    favicon: "/favicon-seucredito.png",
    card: "/cartao_beneficio-seucredito.jpg",
    refinCard: "/cartao_beneficio-seucredito.jpg",
    consignedCard: "/cartao_consignado-seucredito.jpg",
    bankLogo: "",
    bank_name: "bmp",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#042940",
      },
    },
    assets: {
      logo: "/logo-banese.png",
      favicon: "/favicon-banese.png",
    },
  },
};

export default settings;
